import { membershipRoles, readTokenClaims, resolveMembershipTenant } from './firstLoginAccess'

const array = (value) => value == null ? [] : Array.isArray(value) ? value : [value]

// Shared by email login, Google login and AuthProvider (reload/token refresh).
export function buildAuthPayload(token, profileData = {}, firebaseUser = {}, firebaseClaims = readTokenClaims(token), expectedTenantId = null) {
  const profile = profileData.profile || {}
  const rawClaims = profileData.token?.claims
  const profileClaims = rawClaims == null ? null : typeof rawClaims === 'object' && !Array.isArray(rawClaims) ? rawClaims : {}
  const claims = profileClaims || {}
  const provider = firebaseUser.providerData?.[0] || {}
  const memberships = array(profileData.memberships)
  const userId = profile.id || firebaseUser.uid || firebaseClaims.sub || null
  const tenantId = resolveMembershipTenant({
    token, profileClaims, memberships, userId,
    expectedTenantId,
  })
  const profileRoles = array(profileData.roles)
  const tokenRoles = array(claims.roles)
  const claimedRoles = profileRoles.length ? profileRoles : tokenRoles.length ? tokenRoles : array(firebaseClaims.roles)
  const scopedRoles = memberships.filter((m) => (
    tenantId ? m.tenantId === tenantId || !m.tenantId : !m.tenantId
  )).flatMap(membershipRoles)
  const roles = [...new Set([...claimedRoles, ...scopedRoles])]
  const profilePermissions = array(profileData.permissions)
  const permissions = profilePermissions.length ? profilePermissions : array(claims.permissions || firebaseClaims.permissions)
  const membershipBusinesses = memberships.map((m) => m.business || m).filter(Boolean)
  const profileBusinesses = array(profileData.businesses)
  const businesses = membershipBusinesses.length ? membershipBusinesses : profileBusinesses.length ? profileBusinesses : array(firebaseClaims.clients ?? firebaseClaims.businesses)
  const username = profile.email || profile.username || firebaseUser.email || provider.email || firebaseClaims.email || firebaseUser.uid || ''

  return {
    token, profileClaims, memberships, tenantId, roles, permissions, businesses,
    displayName: profile.displayName || profile.name || firebaseUser.displayName || provider.displayName || firebaseClaims.name || username,
    username,
    profileUrl: profile.avatarUrl || profileData.profileUrl || firebaseUser.photoURL || provider.photoURL || firebaseClaims.picture || null,
    status: profileData.status || profile.status || null,
    userId,
  }
}
